module.exports = __webpack_public_path__ + "img/logo-with-bg.81277c35.png";